import React from "react";
import { LuGitCompare } from "react-icons/lu";

// "N selected" + Compare button (top right of a record's table)
export default function CompareToolbar({ count, showError, onCompare }) {
  return (
    <div className="d-flex align-items-center justify-content-end gap-3 mb-2">
      <span className={`small ${showError ? "text-danger" : "text-secondary"}`}>
        {showError ? "Select at least 2 stages with data" : `${count} selected`}
      </span>
      <button type="button" className="btn btn-sm btn-primary" onClick={onCompare}>
        <LuGitCompare className="me-2" />
        Compare
      </button>
    </div>
  );
}
